{
  "version": 1,
  "asset_id": "075ac65a-748f-46b2-92fe-ed827b133b81",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/075ac65a-748f-46b2-92fe-ed827b133b81/hiatal-type-3-story-hernia-es-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/075ac65a-748f-46b2-92fe-ed827b133b81/hiatal-type-3-story-hernia-es-480.webp",
  "original_filename": "hiatal-type-3-story-hernia-es-480.webp",
  "size": 21010,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:20Z"
}
